// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zFw-","left":"styles_left__1MsVv","desktopActions":"styles_desktopActions__3AoSL","title":"styles_title__1ozAA"};